export default () => {
	for (const item of document.querySelectorAll("[data-clear]")) {
		item.addEventListener("click", () => {
			const targetId = item.getAttribute("data-clear");
			const target = document.getElementById(targetId);
			if (target !== null) {
				target.value = "";
				target.focus();
			}
		});
	}
};
